/* eslint-disable no-console */
console.log( 'Hello World! (from create-block-slideshow block)' );
/* eslint-enable no-console */
